module.exports = __webpack_public_path__ + "img/13.cb1160b7.png";